var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-content product-tab-content" }, [
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("list"),
        attrs: { id: "products-list" }
      },
      [
        _c("products-new-grouped-by-asin", {
          attrs: {
            hasRefreshGroupTable: _vm.hasRefreshGroupTable,
            currentTab: _vm.tab,
            banner: _vm.banners.productListBanner || ""
          },
          on: {
            handleNotRefreshGroupTable: function($event) {
              _vm.hasRefreshGroupTable = $event
            },
            handleRefreshAmazonTable: function($event) {
              _vm.hasRefreshAmazonTable = $event
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("add-by-amazon"),
        attrs: { id: "add-by-amazon" }
      },
      [
        _c("product-new-add", {
          attrs: {
            currentTab: _vm.tab,
            banner: _vm.banners.productAddBanner || "",
            hasRefreshAmazonTable: _vm.hasRefreshAmazonTable
          },
          on: {
            handleNotRefreshAmazonTable: function($event) {
              _vm.hasRefreshAmazonTable = $event
            },
            handleRefreshGroupTable: function($event) {
              _vm.hasRefreshGroupTable = $event
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("reports"),
        attrs: { id: "reports" }
      },
      [_c("product-reports", { attrs: { currentTab: _vm.tab } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b5c7a78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5c7a78","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/TabContent.vue
// module id = null
// module chunks = 